// extracted by mini-css-extract-plugin
export default {"page":"_7QTr4","previous":"_7nCim","first":"_7j8KK","next":"XN7yC","last":"nfSoQ","active":"s04yv","large":"nLKeO","arrow":"_4OWY8","inner":"heulY"};